// generated from 207 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const productPurchasedFirstSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("product_purchased_first_since_filter"),
  comparison_key: z.enum([
    "4", // 110 (53.14%)
    "3", // 54 (26.09%)
    "6", // 33 (15.94%)
    "5", // 10 (4.83%)
  ]),
  display_name: z.string(),
  // undefined: 54 (26.09%), defined 153 (73.91%)
  raw_value: z
    .union([
      // number samples: 108 (70.59%)
      // integer: 99 (91.67%)
      // avg: 18.61, min: 0.29166666666666663, max: 181
      z.number().nonnegative(),
      // string samples: 45 (29.41%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 143 (69.08%)
    // integer: 134 (93.71%)
    // avg: 23.41, min: 0.29166666666666663, max: 181
    z.number().nonnegative(),
    // string samples: 64 (30.92%)
    common.date,
  ]),
  varies_by_app_group: z.literal(true),
});
